import { UserBlockedIcon, UserCheckedIcon, WorkOffIcon } from 'tdesign-icons-react';
import { Tag } from 'tdesign-react';

// 变量可选
export const variableOptionalOptions = [
  { value: 0, label: '必填变量' },
  { value: 1, label: '选填变量' },
];

// 主机类型字典
export const CLUSTER_TYPES = Object.freeze({
  HOST: 0,
  K8S: 1,
});

export const clusterTypeOptions = [
  { value: 0, label: '主机' },
  { value: 1, label: 'k8s容器' },
];

// 集群分类
export const clusterCategoryOptions = Object.freeze([
  { value: 'pulsar', label: 'Pulsar' },
  { value: 'kop', label: 'Kop' },
  { value: 'kafka', label: 'Kafka' },
]);

// 脚本类型
export const codeTypeOptions = [
  { label: 'Shell', value: 0, type: 'shell' },
  { label: 'Python', value: 1, type: 'python' },
];

// 变量类型
export const variableTypeOptions = [
  {
    label: '组件变量',
    value: 1,
  },
  {
    label: '脚本变量',
    value: 0,
  },
];

// 任务类型
export const jobOptions = [
  {
    label: '脚本任务',
    value: 0,
  },
  {
    label: '组件任务',
    value: 1,
  },
  {
    label: '流程任务',
    value: 2,
  },
];

// 模板类型
export const stencilTypeOptions = [
  { label: '脚本', value: 0 },
  { label: '组件', value: 1 },
  { label: '系统任务', value: 2 },
];

// 执行状态
export const processStatusOptions = [
  { label: '进行中', value: 0, status: 'Processing' },
  { label: '结束', value: 1, status: 'Default' },
  { label: '停止', value: 2, status: 'Default' },
  { label: '重试当前节点', value: 3, status: 'Processing' },
  { label: '重试并继续', value: 4, status: 'Processing' },
];

// 执行结果
export const executeResultOptions = [
  { value: 0, label: '进行中', status: 'Processing' },
  { value: 1, label: '错误', status: 'Error' },
  { value: 2, label: '成功', status: 'Success' },
  { value: 3, label: '终止', status: 'Warning' },
];

// 执行状态
export const componentStatusOptions = [
  { label: '初始化', value: 'READY', status: 'Default' },
  { label: '正在执行脚本', value: 'PROCESSING', status: 'Processing' },
  { label: '执行脚本错误', value: 'ERROR', status: 'Error' },
  { label: '运行中', value: 'ALIVE', status: 'Success' },
  { label: '已停止', value: 'STOP', status: 'Default' },
];

// 菜单类型
export const menuTypeOptions = Object.freeze([
  {
    value: 0,
    label: '菜单',
  },
  {
    value: 1,
    label: '按钮',
  },
  {
    value: 2,
    label: '内容',
  },
]);

// 用户户状态
export const userStatusOptions = Object.freeze([
  {
    value: 0,
    label: '启用',
    render: (
      <Tag theme='success' size='small' variant='light-outline' icon={<UserCheckedIcon />}>
        启用
      </Tag>
    ),
  },
  {
    value: 1,
    label: '禁用',
    render: (
      <Tag theme='default' size='small' variant='light-outline' icon={<UserBlockedIcon />}>
        禁用
      </Tag>
    ),
  },
  {
    value: 2,
    label: '离职',
    render: (
      <Tag theme='default' size='small' variant='light-outline' icon={<WorkOffIcon />}>
        离职
      </Tag>
    ),
  },
]);

export const consumptionOptions = Object.freeze([
  {
    value: 'Ack',
    label: '确认',
  },
  {
    value: 'Dispatch',
    label: '推送',
  },
]);

// 流程节点
export const flowNodeTaskOptions = [
  { value: 1, label: '部署/升级' },
  { value: 2, label: '回滚' },
  { value: 3, label: '卸载' },
  { value: 4, label: '启动/重启' },
  { value: 5, label: '停止' },
];

// 系统任务
export const systemNodeTaskOptions = [{ value: 20, label: '文件上传（自定义路径）' }];

// 脚本时流程节点
export const flowGroupRuleOptionsScript = [{ value: 1, label: '执行' }];

// 节点所在主机组执行规则
export const flowGroupRuleOptions = [
  {
    value: 1,
    label: '全部主机都执行',
  },
  {
    value: 2,
    label: '只在第一台主机执行',
  },
];

// bool类型是否
export const boolYesNoOptions = [
  {
    value: true,
    label: '是',
  },
  {
    value: false,
    label: '否',
  },
];

// 0,1 int类型是否
export const intYesNoOptions = [
  {
    value: 1,
    label: '是',
  },
  {
    value: 0,
    label: '否',
  },
];

// 常用一些颜色
export const colors = [
  '#0B6065',
  '#0F8D7F',
  '#14B7A5',
  '#22C45E',
  '#83CB16',
  '#C7CB16',
  '#E9B208',
  '#F49D0B',
  '#E44',
  '#992727',
];

// 图表基础颜色
export const chartColors = ['#3361FF', '#14B7A5', '#E9B208'];
// 时延图表用
export const publishLatencyChartColors = colors.reverse();

// 变量域 变量类型
export const scopeTypeOptions = [
  {
    value: 0,
    label: '主机变量',
    eventId: 'TEMPLATE_DETAIL_VARIABLE_HOST',
  },
  {
    value: 1,
    label: '容器变量',
    eventId: 'TEMPLATE_DETAIL_VARIABLE_CONTAINER',
  },
];

// 变量级别
export const variableLevelOptions = [
  {
    value: 0,
    label: '集群变量',
  },
  {
    value: 1,
    label: 'IP级变量',
  },
];

// 变量展现形式
export const showTypeOptions = Object.freeze([
  {
    value: 1,
    label: '文本框',
  },
  {
    value: 2,
    label: '下拉框',
  },
  {
    value: 3,
    label: '数字',
  },
]);

// 其他默认值模板中的值和default保持一致
export const sameValueOptions = Object.freeze([
  {
    label: '是',
    value: true,
  },
  {
    label: '否，需要依次赋值',
    value: false,
  },
]);

export const offsetPositionOptions = Object.freeze([
  {
    label: '最近位点',
    value: 'latest',
  },
  {
    label: '最早位点',
    value: 'earliest',
  },
]);

// 巡检模块 Node,Bookie,Broker,Zookeeper,GeoReplication,ConsumerGroup,Topic,DisasterRecovery
export const checkTypeOptions = Object.freeze([
  {
    label: 'Node',
    value: 'Node',
  },
  {
    label: 'Bookie',
    value: 'Bookie',
  },
  {
    label: 'Broker',
    value: 'Broker',
  },
  {
    label: 'Zookeeper',
    value: 'Zookeeper',
  },
  {
    label: 'GeoReplication',
    value: 'GeoReplication',
  },
  {
    label: 'ConsumerGroup',
    value: 'ConsumerGroup',
  },
  {
    label: 'Topic',
    value: 'Topic',
  },
  {
    label: 'DisasterRecovery',
    value: 'DisasterRecovery',
  },
]);

// 消息类型
export const messageTypes = Object.freeze({
  /* 头部提示的，单点登陆用户不能修改密码相关 */
  HEADER_MESSAGE_IS_ORDINARY_USER: 'HEADER_MESSAGE_IS_ORDINARY_USER',
  /* 集群列表引导 */
  GUIDES_CLUSTER_LIST_GUIDE: 'GUIDES_CLUSTER_LIST_GUIDE',
});
